import { NgModule } from '@angular/core';
import { SearchComponent } from '~shared/svgs';


@NgModule({
  declarations: [
    SearchComponent
  ],
  exports: [
    SearchComponent
  ]
})
export class SearchModule {}
